import axios from 'axios';

const api = axios.create({
  //baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/',
  baseURL: process.env.REACT_APP_API_URL || 'https://crm-backend-form-crefaz.03w0ec.easypanel.host/',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error('[API Error]', err?.response?.status, err?.message);
    return Promise.reject(err);
  }
);

export default api;
